import { effect, inject } from '@angular/core';
import { signalStore, withHooks, withState } from '@ngrx/signals';
import { BaseState, withCrudOperations } from '../crud.state';
import { withComparisonValueSelectors } from './comparison-value.selectors';
import { ComparisonValue } from '../../models/geo-data';
import { ComparisonValueService } from '../../services/comparison-value.service';
import { withLogging } from '../features/logger.feature';
import { ActiveUserStore } from '../user/active-user.state';

export type ComparisonValueState = BaseState<ComparisonValue>;

export const initialState: ComparisonValueState = {
  items: {},
  loading: false,
  selectedId: '',
  selection: [],
  initialized: false,
  itemsLoaded: false,
  version: 0,
  lastPersistedId: '',
  trigger: undefined,
  entityType: 'ComparisonValue',
  entityLabel: 'Vergleichswert',
  filter: {
    query: '',
    category: [],
    tags: undefined,
    products: undefined,
    published: null,
    locked: null,
    ids: undefined,
  },
};

export const ComparisonValueStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withCrudOperations<ComparisonValue>(ComparisonValueService),
  withLogging(initialState.entityType),
  withComparisonValueSelectors(),
  withHooks({
    onInit(store, activeUserStore = inject(ActiveUserStore)) {
      // See category.state.ts for why this watches commune reactively
      // instead of firing once at construction time.
      effect(
        () => {
          if (activeUserStore.commune()) {
            store.loadAllItemsByPromise();
          }
        },
        { allowSignalWrites: true }
      );
    },
  })
);
